import { HttpClientModule } from "@angular/common/http";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Data } from "@angular/router";
import { Router } from "@angular/router";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { User } from "../../model/user";
import { UsersService } from "../../services/users.service";
import { DeliveryClosureService } from "../../services/delivery-closure.service";
import * as moment from "moment";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.sass"],
})
export class HeaderComponent implements OnInit {
  constructor(
    private httpService: HttpClient,
    private usersService: UsersService,
    private route: ActivatedRoute,
    private spinnerService: Ng4LoadingSpinnerService,
    private router: Router,
    private deliveryClosureService: DeliveryClosureService
  ) {
  }

  isIE: boolean;
  userData: Object;
  loggedInAccount: string;
  oe_url: string;
  user: User = new User();
  userAPIDataFromSessionStorage: any;
  isUserShowing: boolean = false;
  shipToIndex;
  headerTitle: string;

  sortedShiptosData;

  // Storefronts
  RI_STOREFRONT: Array<String> = [
    "G-EXT-RWO-RETAIL_INDEPENDENT_ORDERING__PORTAL__ROLE__ADMIN__",
    "G-EXT-RWO-RETAIL_INDEPENDENT_ORDERING__PORTAL__ROLE__BUYER__",
    "G-EXT-RWO-RETAIL_INDEPENDENT_ORDERING__PORTAL__ROLE__READONLY__",
    "g-ext-rwo-retail_independent_ordering__portal__role__admin__",
    "g-ext-rwo-retail_independent_ordering__portal__role__buyer__",
    "g-ext-rwo-retail_independent_ordering__portal__role__readonly__",
    "G-EXT-GA-PHARMACEUTICAL_DISTRIBUTION__RETAIL_INDEPENDENT__RETAIL_INDEPENDENT_ORDERING__BUYER",
    "G-EXT-GA-PHARMACEUTICAL_DISTRIBUTION__RETAIL_INDEPENDENT__RETAIL_INDEPENDENT_ORDERING__ADMIN",
    "WEB_ORDERING_RI",
    "G-EXT-GA-PHARMACEUTICAL_DISTRIBUTION__RETAIL_INDEPENDENT__RETAIL_INDEPENDENT_ORDERING__NON_ORDERING"
  ];

  ACUTE_STOREFRONT: Array<String> = [
    "G-EXT-GA-PHARMACEUTICAL_DISTRIBUTION__ACUTE_CARE__ACUTE_CARE_ORDERING__ADMIN",
    "G-EXT-GA-PHARMACEUTICAL_DISTRIBUTION__ACUTE_CARE__ACUTE_CARE_ORDERING__BUYER",
    "G-EXT-GA-PHARMACEUTICAL_DISTRIBUTION__ORDER_EXPRESS-VA__VA_ORDERING__BUYER",
    "G-EXT-GA-PHARMACEUTICAL_DISTRIBUTION__ORDER_EXPRESS-VA__VA_ORDERING__ADMIN",
    "WEB_ORDERING_AC",
  ];

  ngOnInit() {
    const reg = new RegExp("MSIE|Trident", "g");
    this.getAccounts();
    this.oe_url = this.usersService.getOrderExpressURL();

    this.route.data.subscribe((data: Data) => {
      this.headerTitle = data["headerTitle"];
    });

    this.isIE = reg.test(window.navigator.userAgent);

  }

  public getAccounts() {
    this.shipToIndex = sessionStorage.getItem("shiptoIndex");
    if (this.shipToIndex !== null) {
      this.shipToIndex = sessionStorage.getItem("shiptoIndex");
    } else {
      this.shipToIndex = 0;
    }
    this.userAPIDataFromSessionStorage = JSON.parse(
      sessionStorage.getItem("userAPIData")
    );
    //this.spinnerService.show();
    if (this.userAPIDataFromSessionStorage === null) {
      this.usersService.callTokenGenerator().subscribe(
        (data) => {
          //this.accessToken = data.access_token;
          sessionStorage.setItem("accessToken", data.access_token);
          this.spinnerService.show();
          this.usersService
            .getUsersData()

            .subscribe(
              (data) => {
                this.sortedShiptosData = this.sortShipATos(
                  this.checkForAliasIsBlank(data.shipTos)
                );
                sessionStorage.setItem(
                  "sortedShipTos",
                  JSON.stringify(this.sortedShiptosData)
                );
                this.loggedInAccount = "Test API Call";
                this.user.firstName = data.firstName;
                this.user.shipTos = this.sortedShiptosData;
                this.user.lastName = data.lastName;
                this.user.userDisplayName = data.userDisplayName;
                this.user.email = data.email;
                this.user.activeAccount = this.sortedShiptosData[
                  this.shipToIndex
                ].name;
                sessionStorage.setItem("userAPIData", JSON.stringify(data));
                if (window.location.href.indexOf("deeplink=preferences") > -1) {
                  this.router.navigate(["/preferences"]);
                }
                this.spinnerService.hide();
                //Analytics
                window["pageData"].visitor = {
                  accountID: data.shipTos[this.shipToIndex].customerNumber,
                  dc: data.shipTos[this.shipToIndex].distributionCenter,
                  userID: data.id,
                };
              },
              (error) => {}
            );
        },
        (error) => {}
      );
    } else {
      this.loggedInAccount = "Test Existing";
      this.sortedShiptosData = this.sortShipATos(
        this.checkForAliasIsBlank(this.userAPIDataFromSessionStorage.shipTos)
      );
      sessionStorage.setItem(
        "sortedShipTos",
        JSON.stringify(this.sortedShiptosData)
      );
      this.user.firstName = this.userAPIDataFromSessionStorage.firstName;
      this.user.shipTos = this.sortedShiptosData;
      this.user.lastName = this.userAPIDataFromSessionStorage.lastName;
      this.user.userDisplayName = this.userAPIDataFromSessionStorage.userDisplayName;
      this.user.email = this.userAPIDataFromSessionStorage.email;
      this.user.activeAccount = this.sortedShiptosData[this.shipToIndex].name;

      if (window.location.href.indexOf("deeplink=preferences") > -1) {
        this.router.navigate(["/preferences"]);
        //this.spinnerService.hide();
      }
      //Analytics
      let storefront = '';
      this.userAPIDataFromSessionStorage.userSettings.memberGroups.forEach((t) => {
        let group = t.split(',')[0].split('cn=')[1];
        if ( this.RI_STOREFRONT.includes(group) ) {
          storefront = "retail";
        }
        if ( this.ACUTE_STOREFRONT.includes(group) ) {
          storefront = "acute";
        }
      });

      let href = window.location.href;
      let env = '';
      if (href.indexOf('local') > -1) { env = 'dev' }
      else if (href.indexOf('dev') > -1) { env = 'dev' }
      else if (href.indexOf('stg') > -1) { env = 'stg' }
      else { env = 'prod' }

      let date = moment().format("L");

      window["pageData"].visitor = {
        loggedIn: this.userAPIDataFromSessionStorage.id ? 'logged in' : 'not logged in',
        loginID: this.userAPIDataFromSessionStorage.id,
        storefront: storefront,
        marketingCodes: this.sortedShiptosData[this.shipToIndex].marketingCodes,
        website: "pharma",
        env: env,
        pageType: "Delivery Closure",
        pageName: "Delivery Closure",
        date: date,
        accountID: this.sortedShiptosData[this.shipToIndex].customer,
        dc: this.sortedShiptosData[this.shipToIndex].dc,
        userID: this.userAPIDataFromSessionStorage.id,
      };
      if(typeof window["_satellite"] != 'undefined' && window["_satellite"]) {
        window["_satellite"].track("Event-Store-Closure-Page");
      }
    }
  }

  onAccountSelection(index: number) {
    this.deliveryClosureService.selectedPharmacy(index);

    this.userAPIDataFromSessionStorage = JSON.parse(
      sessionStorage.getItem("userAPIData")
    );
    sessionStorage.setItem("shiptoIndex", index.toString());
    this.user.activeAccount = this.sortedShiptosData[index].name;

    let storefront = '';
    this.userAPIDataFromSessionStorage.userSettings.memberGroups.forEach((t) => {
      let group = t.split(',')[0].split('cn=')[1];
      if ( this.RI_STOREFRONT.includes(group) ) {
        storefront = "retail";
      }
      if ( this.ACUTE_STOREFRONT.includes(group) ) {
        storefront = "acute";
      }
    });

    let href = window.location.href;
    let env = '';
    if (href.indexOf('local') > -1) { env = 'dev' }
    else if (href.indexOf('dev') > -1) { env = 'dev' }
    else if (href.indexOf('stg') > -1) { env = 'stg' }
    else { env = 'prod' }

    let date = moment().format("L");

    //Analytics
    window["pageData"].visitor = {
      loggedIn: this.userAPIDataFromSessionStorage.id ? 'logged in' : 'not logged in',
      loginID: this.userAPIDataFromSessionStorage.id,
      storefront: storefront,
      marketingCodes: this.sortedShiptosData[index].marketingCodes,
      website: "pharma",
      env: env,
      pageType: "Delivery Closure",
      pageName: "Delivery Closure",
      date: date,
      accountID: this.sortedShiptosData[index].customer,
      dc: this.sortedShiptosData[index].dc,
      userID: this.userAPIDataFromSessionStorage.id,
    };
  }

  sortShipATos(shipTos) {
    return shipTos.sort((a, b) => {
      if (a.name === b.name) {
        if (a.dc === b.dc) {
          if (a.customer < b.customer) {
            return -1;
          }
          if (a.customer > b.customer) {
            return 1;
          }
          return 0;
        } else {
          if (a.dc < b.dc) {
            return -1;
          }
          if (a.dc > b.dc) {
            return 1;
          }
          return 0;
        }
      } else {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      }
    });
  }

  checkForAliasIsBlank(shipTos) {
    let newShipTos = [];
    for (let i = 0; i < shipTos.length; i++) {
      let shipTosObject = {
        name: "",
        dc: "",
        customer: "",
        address: "",
        address1: "",
        address2: "",
        address3: "",
        marketingCodes: []
      };

      let m: Array<Number> = [];
      if ( shipTos[i].marketingPrograms ) {
        shipTos[i].marketingPrograms.forEach((t) => {
          m.push(t.code);
        })
      }

      if (shipTos[i].alias !== "") {
        shipTosObject.name = shipTos[i].alias;
        shipTosObject.dc = shipTos[i].distributionCenter;
        shipTosObject.customer = shipTos[i].customerNumber;
        let zip = shipTos[i].zipCode;
        // shipTosObject.address = shipTos[i].address1 + ", " + shipTos[i].city + ", " + shipTos[i].state + " " + zip.substring(0, 5);
        shipTosObject.address1 = shipTos[i].address1;
        shipTosObject.address2 = shipTos[i].address2;
        shipTosObject.address3 =
          shipTos[i].city +
          ", " +
          shipTos[i].state +
          ", " +
          zip.substring(0, 5);
        shipTosObject.marketingCodes = m;
      } else {
        shipTosObject.name = shipTos[i].name;
        shipTosObject.dc = shipTos[i].distributionCenter;
        shipTosObject.customer = shipTos[i].customerNumber;
        let zip = shipTos[i].zipCode;
        // shipTosObject.address = shipTos[i].address1 + ", " + shipTos[i].city + ", " + shipTos[i].state + " " + zip.substring(0, 5);
        shipTosObject.address1 = shipTos[i].address1;
        shipTosObject.address2 = shipTos[i].address2;
        shipTosObject.address3 =
          shipTos[i].city +
          ", " +
          shipTos[i].state +
          ", " +
          zip.substring(0, 5);
        shipTosObject.marketingCodes = m;
      }
      newShipTos[i] = shipTosObject;
    }

    return newShipTos;
  }

  toggleUserDropdown() {
    this.isUserShowing = !this.isUserShowing;
  }
}
